import ParticleBackground from "../components/ParticleBackground";
import { Card } from "../components/ui/card";
import "../styles/home.css";
import "../styles/premium-enhancements.css";
import { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    document.title = "Terms & Conditions | aiwebAA";
    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
      canonical.href = "https://aiwebaa.com/terms";
    }
  }, []);

  return (
    <div className="home-container">
      <ParticleBackground />
      <div className="aurora-bg"></div>

      <section
        className="services-section"
        style={{
          minHeight: "100vh",
          paddingTop: "120px",
          paddingBottom: "120px",
        }}
      >
        <Card
  className="glass-card-premium neon-border fade-in-up"
  style={{
    maxWidth: "900px",
    margin: "0 auto",
    padding: "50px",
  }}
>

          <h1 className="section-title" style={{ textAlign: "center" }}>
            Terms & <span className="gradient-text">Conditions</span>
          </h1>

          <p
            className="section-subtitle"
            style={{ textAlign: "center", marginBottom: "40px" }}
          >
            Please read these terms carefully before using aiwebAA
          </p>

          <div className="privacy-content">
            <h3>Acceptance of Terms</h3>
            <p>
              By accessing or using aiwebAA, you agree to be bound by these
              Terms & Conditions. If you do not agree, please do not use our
              services.
            </p>

            <h3>Services</h3>
            <p>
              aiwebAA provides AI-powered website development, automation,
              branding, and related digital services. Service scope, pricing,
              and timelines are agreed upon before project initiation.
            </p>

            <h3>Payments</h3>
            <p>
              Payments made for services are non-refundable unless otherwise
              stated in a written agreement. Any additional work beyond the
              agreed scope may incur extra charges.
            </p>

            <h3>Intellectual Property</h3>
            <p>
              All designs, code, and materials remain the property of aiwebAA
              until full payment is received. Upon completion and payment,
              ownership is transferred unless otherwise agreed.
            </p>

            <h3>Client Responsibilities</h3>
            <p>
              Clients are responsible for providing accurate information,
              content, and approvals required to complete the project on time.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
              aiwebAA shall not be liable for any indirect, incidental, or
              consequential damages arising from the use of our services.
            </p>

            <h3>Third-Party Tools</h3>
            <p>
              We may use third-party tools, platforms, or services to deliver
              projects. aiwebAA is not responsible for third-party outages or
              policy changes.
            </p>

            <h3>Termination</h3>
            <p>
              We reserve the right to suspend or terminate services if these
              terms are violated or misuse is detected.
            </p>

            <h3>Changes to Terms</h3>
            <p>
              aiwebAA may update these Terms & Conditions at any time. Continued
              use of the website constitutes acceptance of the updated terms.
            </p>

            <h3>Contact</h3>
            <p>
              For any questions regarding these terms, contact us at
              <strong> hello@aiwebaa.com</strong>
            </p>
          </div>
        </Card>
      </section>
    </div>
  );
};

export default Terms;
